export default __webpack_public_path__ + "static/media/Icons_Help Icon.f5d9af75.svg";